import ContactEditField from 'flow/components/contact-components/ContactEditField';
import NumberField from 'flow/components/custom-components/NumberFieldSmart';
import { isEmptyNullOrUndefined } from 'flow/utils';
import { ContactFull } from 'flow/types/Contact';
import { TypedMap } from 'flow/types/TypedMap';
import useAppContext from 'flow/hooks/useAppContext';

interface Props {
    userCountryCode: string;
    updatedContact: TypedMap<ContactFull>;
    updateContact: (contact: TypedMap<ContactFull>) => void;
}

const CreateContact = ({
    userCountryCode,
    updatedContact,
    updateContact,
}: Props) => {
    const { i18next } = useAppContext();

    const updateContactString = (evt: any) => {
        let editedContact;
        const value = evt.target.value;

        //If we empty a field in the create flow remove it from the creation list to make sure the save validation works
        //as intended

        if (isEmptyNullOrUndefined(value)) {
            if (updatedContact.has(evt.target.id)) {
                editedContact = updatedContact.delete(evt.target.id);
            } else {
                editedContact = updatedContact;
            }
        } else {
            editedContact = updatedContact.update(evt.target.id, () => value);
        }

        handlePrepareContact(editedContact);
    };

    const updateContactNumber = (id: string, number: string) => {
        const editedContact = updatedContact.updateIn(
            [id, 'number'],
            () => number,
        );
        handlePrepareContact(editedContact);
    };

    const handlePrepareContact = (editedContact: TypedMap<ContactFull>) => {
        if (updatedContact !== editedContact) {
            updateContact(editedContact);
        }
    };

    return (
        <div className="flex flex-col gap-3 px-6 pb-3">
            <ContactEditField
                key="firstname-textfield"
                field_key="firstName"
                field_value={updatedContact.get('firstName')}
                field_func={updateContactString}
                label={i18next.t('ContactCard.Items.FirstName')}
            />
            <ContactEditField
                key="lastname-textfield"
                field_key="lastName"
                field_value={updatedContact.get('lastName')}
                field_func={updateContactString}
                label={i18next.t('ContactCard.Items.LastName')}
            />
            <NumberField
                key="anumber-numberfield"
                id="fixed"
                numberDTO={updatedContact.get('fixed')}
                onChange={updateContactNumber}
                label={i18next.t('ContactCard.Items.FixedPhone')}
                disabled={false}
                defaultCountryCode={userCountryCode}
            />
            <NumberField
                key="mobile-numberfield"
                id="mobile"
                numberDTO={updatedContact.get('mobile')}
                onChange={updateContactNumber}
                label={i18next.t('ContactCard.Items.MobilePhone')}
                disabled={false}
                defaultCountryCode={userCountryCode}
            />
            <ContactEditField
                key="email-textfield"
                field_key="email"
                field_value={updatedContact.get('email')}
                field_func={updateContactString}
                label={i18next.t('ContactCard.Items.Email')}
            />
            <ContactEditField
                key="companyname-textfield"
                field_key="companyName"
                field_value={updatedContact.get('companyName')}
                field_func={updateContactString}
                label={i18next.t('ContactCard.Items.Company')}
            />
            <ContactEditField
                key="department-textfield"
                field_key="department"
                field_value={updatedContact.get('department')}
                field_func={updateContactString}
                label={i18next.t('ContactCard.Items.Department')}
            />
            <ContactEditField
                key="occupation-textfield"
                field_key="occupation"
                field_value={updatedContact.get('occupation')}
                field_func={updateContactString}
                label={i18next.t('ContactCard.Items.Occupation')}
            />
            <ContactEditField
                key="address-textfield"
                field_key="address"
                field_value={updatedContact.get('address')}
                field_func={updateContactString}
                label={i18next.t('ContactCard.Items.Address')}
            />
            <ContactEditField
                key="postalcode-textfield"
                field_key="postalcode"
                field_value={updatedContact.get('postalcode')}
                field_func={updateContactString}
                label={i18next.t('ContactCard.Items.PostalCode')}
            />
            <ContactEditField
                key="city-textfield"
                field_key="city"
                field_value={updatedContact.get('city')}
                field_func={updateContactString}
                label={i18next.t('ContactCard.Items.City')}
            />
            <ContactEditField
                key="country-textfield"
                field_key="country"
                field_value={updatedContact.get('country')}
                field_func={updateContactString}
                label={i18next.t('ContactCard.Items.Country')}
            />
            <ContactEditField
                key="description-textfield"
                field_key="description"
                field_value={updatedContact.get('description')}
                field_func={updateContactString}
                label={i18next.t('ContactCard.Items.Description')}
            />
            <ContactEditField
                key="keywords-textfield"
                field_key="keywords"
                field_value={updatedContact.get('keywords')}
                field_func={updateContactString}
                label={i18next.t('ContactCard.Items.Keywords')}
            />
        </div>
    );
};

export default CreateContact;
